export class SoCountDetail {
    finYear: Date;
    finMonth: string;
    plant_code: string;
    openSos: number;
    closesSos: number;
    cancelledSos: number;
}